<template lang="pug">
.page
    h3.empty-folder(v-if="groups.length == 0") 文件夹为空，请联系管理员！
    .folder(v-else)
        .folder-tree(v-show="showFolderTree" :style="{height: isEmbedded ? 'calc(100vh - 50px)' : 'calc(100vh - 10px)'}")
            .folder-group-list(v-if="uploadingItems.length == 0")
                .folder-root-item(
                    v-for="g in groups" 
                    :key="g.name" 
                    :style="{backgroundColor: currentGroup==g.name ? 'white' : ''}"
                    @click="gotoGroup(g.name)")
                    a-icon(type="folder-open" 
                        style="color:#79cdfd" 
                        theme="filled" 
                        v-if="currentGroup == g.name")
                    a-icon(type="folder" 
                        theme="filled" 
                        style="color:#79cdfd" 
                        v-else)
                    span(style="flex:1; margin-left:10px") {{g.name}}

            .folder-upload(v-else)
                a-list(bordered 
                    :data-source="uploadingItems")
                    a-list-item(slot="renderItem" slot-scope="item")
                        span {{item.name}}
                        a-icon(type="loading" spin)

        .folder-content
            a-icon.folder-toggle-btn(
                :type="showFolderTree ? 'menu-fold' : 'menu-unfold'" 
                @click="showFolderTree = !showFolderTree"
            )
            Folder(:group="currentGroup" 
                :root="root" 
                :style="{height: isEmbedded ? 'calc(100vh - 50px)' : 'calc(100vh - 10px)'}"
                :key="currentGroup"
                v-if="currentGroup!=''" 
                @addUploadItem="addUploadItem"
                @delUploadItem="delUploadItem"
            )

    a-modal(
        title="登录"
        :visible="loginVisible"
        :footer="null"
        :closable="false"
        :maskClosable="false"
    )
        a-form(:form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }")
            a-form-item(label="用户名")
                a-input(v-decorator="['name', { rules: [{ required: true, message: 'Please input your username!' }] }]" placeholder="用户名")
            a-form-item(label="密码")
                a-input(v-decorator="['password', { rules: [{ required: true, message: 'Please input your password!' }] }]" type="password" placeholder="密码")
            a-form-item(:wrapper-col="{ span: 16, offset: 5 }")
                a-button(type="primary" @click="handleLogin" style="width:100%") 登录

</template>
<script>
// import {mapState} from 'vuex';
import Folder from './Folder.vue';

export default {
    data() {
        let currentGroup = '';
        let isEmbedded = false;
        if (this.$router) {
            currentGroup = this.$route.params.group || '';
            isEmbedded = true;
        }
        

        if (currentGroup == '') {
            currentGroup = localStorage.getItem('lastFolderGroup') || '';
        } else {
            localStorage.setItem('lastFolderGroup', currentGroup);
        }

        let showFolderTree = localStorage.getItem('showFolderTree');
        return {
            loginVisible: false,
            form: this.$form.createForm(this),
            isEmbedded,
            me: {},
            currentGroup,
            root: '',
            groups: [],
            uploadingItems: [],
            showFolderTree: showFolderTree === 'false' ? false : true
        };
    },
    watch: {
        showFolderTree(val) {
            localStorage.setItem('showFolderTree', val);
        },
        currentGroup(val) {
            localStorage.setItem('lastFolderGroup', val);
        }
    },
    async mounted() {
        try {
            await this.getUser();
            this.getData();
        } catch (e) {
            console.error(e);
        }
    },
    methods: {
        gotoGroup(group) {
            this.currentGroup = group;
            for (let i = 0; i < this.groups.length; i++) {
                if (this.groups[i].name == group) {
                    this.root = this.groups[i].root;
                    break;
                }
            }
        },
        addUploadItem(name) {
            this.uploadingItems.push({name});
        },
        delUploadItem(name) {
            this.uploadingItems = this.uploadingItems.filter(item => item.name != name);
        },
        submitDelSubGroup(subGroup) {
            this.$api.request('POST', 'subGroup/del/' + this.currentGroup, {subGroup}, 'fs')
                .then(res => {
                    this.getData();
                });
        },
        async handleLogin() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.$api.request('POST', 'login', values).then(async () => {
                        this.loginVisible = false;
                        await this.getUser();
                        this.getData();
                    }).catch(e => {
                        this.$message.error('登录失败');
                    });
                }
            });
        },
        async getUser() {
            try {
                let res = await this.$api.request('GET', 'me');
                this.me = res.data;
            } catch (e) {
                this.loginVisible = true;
                throw e;
            }
        },
        getData() {
            this.$api.request('GET', 'groups/' + this.me._id, {}, 'fs')
                .then(res => {
                    this.groups = res.data;
                    if (this.currentGroup != '') {
                        this.gotoGroup(this.currentGroup);
                    }
                });
        },  
        handleEdit(targetKey, action) {
            console.log(targetKey, action);
            if (action == 'add') this.addSubGroupVisiable = true;
            else if (action == 'remove') {
                this.$confirm({
                    title: '确定删除' + targetKey + '?',
                    onOk: () => {
                        this.submitDelSubGroup(targetKey);
                    }
                });
            }
        }
    },
    components: {
        Folder
    }
}
</script>

<style lang="less" scoped>
.page {
    padding: 5px;
    overflow: auto;

    .ctl-bar {
        margin-bottom: 10px;
        display: flex;
    }
}

.empty-folder{
    display: block;
    margin: auto;
    width: 100%;
    text-align: center;
    font-size: 20px;
}
.folder {
    display: flex;
    flex-direction: row;
}
.folder-tree {
    width: 240px;
    background-color: #e6e6e6;
    // height: calc(100vh - 15px);
    /* height: 100vh - 40px; */
    overflow: auto;
    // color: white;
    // border-right: solid 3px;

}
.folder-menu {
    padding-top:0px;
    background:#e6e6e6;
    font-size: 16px;
}
.folder-upload {
    position: absolute;
    bottom: 5px;
    width: 235px;
}
.folder-content {
    flex: 1;
    position: relative;
    /deep/ .folder-header {
        padding-left: 40px;
    }
}
.folder-toggle-btn {
    position: absolute;
    top: 14px;
    left: 14px;
    z-index: 9;
    font-size: 18px;
    cursor: pointer;
    transition: color 0.3s;
}
.folder-toggle-btn:hover {
    color: #1890ff;
}
.folder-header {
    padding: 5px 10px;
    background-color: rgb(230, 230, 230);
    font-size: 18px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .folder-ctl {
        font-size: 25px;
    }
}

.folder-group-list {
    padding: 5px;
    font-size: 14px;
    
    .folder-root-item {
        display: block;
        padding: 8px;
        border-radius: 3px;
        cursor: pointer;
        // margin: 3px 0;
        // border: solid 1px #ddd;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .folder-root-item:hover {
        background-color: white;
    }
}
</style>